import api from '@http/api';

export interface IDeleteCorrespDevolvida {
  id: number;
}

class ComponentCorrespondenciaServices {
  public async DeleteCorrespDevolvida({
    id,
  }: IDeleteCorrespDevolvida) {
    return await api
      .post('/api/CorrespondenciaDevolvida/RemoverCorrespondeciaPendente', {
        id,
      })

      .then(response => {
        return {
          error: false,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }
}

export default ComponentCorrespondenciaServices;
